
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import { namespace } from 'vuex-class';

    import "@/store/modules/common";
    const commonState = namespace("Common"); 

    import { lookupsInfoType, aliasInfoType } from '@/types/Information/Form1';   

    @Component
    export default class AddAliasForm extends Vue {        

        @commonState.State
        public lookups!: lookupsInfoType;

        @Prop({required: true})
        formData!: aliasInfoType;

        @Prop({required: true})
        index!: number;

        @Prop({required: true})
        isCreateAlias!: boolean;             

        selectedAliasType = ''
        aliasTypeState = true;     

        aliasName = '';
        aliasNameState = true;         

        originalSelectedAliasType = '';
        originalAliasName = '';  
        
        showCancelWarning = false;

        addButtonText = 'Add';
        dataReady = false;
        
        mounted()
        { 
            this.dataReady = false;
            this.clearSelections();
            if(!this.isCreateAlias) {
                this.extractFormInfo();
                this.addButtonText = 'Save';
            } else {
                this.addButtonText = 'Add';
            }
            this.dataReady = true;              
        }        

        public extractFormInfo(){            
            const index = this.lookups.aliasTypes.findIndex(alias=>{if(alias == this.formData.nameType)return true})
            this.originalSelectedAliasType = this.selectedAliasType = (index>=0)? this.lookups.aliasTypes[index]: '';            
            this.originalAliasName = this.aliasName = this.formData.name;
        }

        public saveForm(){
               
            this.aliasTypeState = this.selectedAliasType != "";
            this.aliasNameState = this.aliasName != ""; 
            
            if (this.aliasTypeState && this.aliasNameState){        
                const alias = {} as aliasInfoType;
                alias.nameType = this.selectedAliasType;
                alias.name = this.aliasName;       
                this.$emit('submit', this.isCreateAlias, alias, this.index);
            }
                
        }

        public closeForm(){
            if(this.isChanged())
                this.showCancelWarning = true;
            else
                this.confirmedCloseForm();
        }

        public isChanged(){
            if(this.isCreateAlias){
                if(this.selectedAliasType.length && this.aliasName.length ) return true;
                return false;
            }else{
                if( (this.originalSelectedAliasType != this.selectedAliasType) ||
                    (this.originalAliasName != this.aliasName)) return true;
                return false;
            }
        }

        public confirmedCloseForm(){           
            this.clearSelections();
            this.$emit('cancel');
        }

        public clearSelections(){
            this.selectedAliasType = '';
            this.aliasName = '';           
            this.aliasNameState  = true;
            this.aliasTypeState   = true;                     
        }
       
    }
